package com.neurobs.ccabserver.transcriptreview.components.transcriptreview

import com.neurobs.ccabserver.transcriptreview.states.{ConfidenceScreenStateProvider, ReviewSelectionState, TestTranscriptReviewData, TestTranscriptReviewStateProvider, VisibilityStateProvider}
import com.neurobs.react.StyleUtil
import slinky.core.{Component, FunctionalComponent}
import slinky.core.annotations.react
import slinky.core.facade.ErrorBoundaryInfo
import slinky.web.html.{className, div, style}

import scala.scalajs.js

/** Displays an element that indicates that something is loading */
@react
object LoadingIndicator {
  case class Props()

  val component = FunctionalComponent[Props] { _ =>
    div(
      className := "ui basic segment",
      style := StyleUtil.makeStyle(("height", "200px"), ("width", "200px"))
    )(
      div(
        className := "ui active text loader",
      )(
        "Loading..."
      )
    )
  }
}

/** This control catches errors thrown in the setup functions used in
 * render methods of sub-controls. Assigning a new key to this control
 * in the parent control will reset the error state. */
@react class TestTranscriptReviewErrorBoundary extends Component {
	case class Props(data: TestTranscriptReviewData)
	case class State(error: String)

	override def initialState: State = State(error = "")

	override def componentDidCatch(error: js.Error, info: ErrorBoundaryInfo): Unit = {
		setState(State(error = error.message))
	}

	override def render() =
		if (state.error.nonEmpty) div(s"Error: ${state.error}")
		else TestTranscriptReviewStateProvider(props.data)(
			VisibilityStateProvider(
				ConfidenceScreenStateProvider(
					TestTranscriptReview()
				)
			)
		)
}

/** This displays either the transcript review controls, a loading message if data for
 * a test transcript is loading, or nothing if no selection has been made
 */
@react
object TestTranscriptReviewHolder {
	case class Props()

	val component = FunctionalComponent[Props] { _ =>
		val selectionState = ReviewSelectionState.accessState()

		if (selectionState.data.value.loading) LoadingIndicator()
		else selectionState.data.value.selection match {
			case None => null
			case Some(sourceData) =>
				TestTranscriptReviewErrorBoundary(sourceData).withKey(sourceData.serverData.selection.transcript.testTranscriptId.toString)
		}
	}
}
